module.exports = __webpack_public_path__ + "static/img/No2.d09c2382.svg";